import { Navigate, Outlet, useLocation } from 'react-router';
import { useAuth } from '@/entities/user';

const UnauthorizedOnlyRoute = () => {
	const location = useLocation();
	const { isLoading, isLoggedIn } = useAuth();

	if (isLoading) {
		return null;
	}

	const redirectPath = location.state?.from?.pathname ?? '/profile';

	return isLoggedIn ? <Navigate to={redirectPath} replace /> : <Outlet />;
};

export default UnauthorizedOnlyRoute;
